module.exports = __webpack_public_path__ + "static/media/lb.993e4302.jpg";